(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('.child-nav-item-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const parent_main = btn.closest('.nav-second-child');
        parent_main.classList.toggle('menu_expand');
      });
    });

    document.querySelectorAll('.drawer-menu-item-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const parent_main = btn.closest('.drawer-menu-item-text');
        document.querySelectorAll('.drawer-menu-item-text').forEach((el)=>{
          if(el != parent_main){el.classList.remove('menu_expanded');} 
        });
        parent_main.classList.toggle('menu_expanded');
      });
    });

    document.querySelectorAll('.drawer-child-menu-item-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.closest('.drawer-second-child').classList.toggle('child_menu_expanded');
      });
    });

    document.querySelector('.menu-drawer--close').addEventListener('click', () => {
      const drawer_close = document.querySelector('.header__icon--menu[aria-label="Menu"]');
      if(drawer_close){
        drawer_close.click();
      }
    });

    window.openSmallWindow = (event) => {
        event.preventDefault(); 
        const url = event.currentTarget.href; 
        const width = 480;
        const height = 240;
        const left = (window.screen.width / 2) - (width / 2);
        const top = 50; 
        window.open(
            url,
            '_blank',
            `width=${width},height=${height},top=${top},left=${left},resizable,scrollbars`
        );
    }

    const Search_Modal = document.querySelector('#Search-In-Modal');
    const Search_wrapper = document.querySelector('.search-modal.modal__content');

    if (Search_Modal){
      Search_Modal.addEventListener('input', () => {
        Search_wrapper.classList.toggle('search_result_found', Search_Modal.value !== '');
      });
    }

  });


  } catch(e) { console.error(e); }
})();
})();
